module.exports = __webpack_public_path__ + "static/media/1 การสมัคร ระบบกู้ยืมเงินทุน.c65639f7.jpg";